import { pipe, find, prop, compose } from "ramda";
import { Td } from "./measurementstable.styles";
import { format } from "utils/format";
import { getPeriod } from "utils/periods";
import { extractValue, measureCodeExplanations, measurementByPeriod, extractMeasurementProp } from "utils/measurement";
import { jsx as _jsx } from "react/jsx-runtime";
export default function MeasurementTableCell(props) {
  var query = props.query,
    measureIdx = props.measureIdx,
    filterEntry = props.filterEntry,
    filterIdx = props.filterIdx,
    periodEntry = props.periodEntry,
    periodIdx = props.periodIdx,
    activeFilters = props.activeFilters,
    availableFilters = props.availableFilters,
    measure = props.measure,
    measureId = props.measureId,
    measurementsWithMetadata = props.measurementsWithMetadata,
    organizationId = props.organizationId;
  var activeMeasure = function activeMeasure(x) {
    return x.organizationId === organizationId && x.measureId === measureId;
  };
  var isValueProp = function isValueProp(x) {
    return x === "value" || x === "reasonCode";
  };
  var extractColumnValue = function extractColumnValue(property, measurement) {
    return measurement ? isValueProp(property) ? compose(format(measure === null || measure === void 0 ? void 0 : measure.measureUnit), extractValue("-"))(measurement) : extractMeasurementProp[property](measurement) : "-";
  };
  var measurement = pipe(find(activeMeasure), prop("measurements"), measurementByPeriod(getPeriod(query.periodType, periodEntry.end)))(measurementsWithMetadata);
  var value = extractColumnValue(filterEntry.id, measurement);
  var title = isValueProp(filterEntry.id) ? compose(measureCodeExplanations, extractValue("-"))(measurement) : undefined;
  return /*#__PURE__*/_jsx(Td, {
    scope: "col",
    title: title,
    borderMe: filterIdx === 0,
    "aria-colindex": periodIdx * query.measureIds.length * availableFilters.length + measureIdx * availableFilters.length + (filterIdx + 2),
    style: activeFilters.includes(filterEntry.id) ? {} : {
      display: "none"
    },
    children: value
  });
}